import {useState} from 'react';
import {gql} from '@apollo/client/core';

import {useSaveSurveyOnboarding, useSurveyQueryOnboarding} from '#apollo/schema';

import {OnSubmitSurveryOpts, QuestionResponse} from './SurveyOnboarding.type';

export const surveyOnboardingMutation = gql`
  mutation SaveSurveyOnboarding($input: SaveUserSurveySubmissionInput!) {
    saveUserSurveySubmission(input: $input) {
      answers {
        questionId
        answerOptionIds
      }
    }
  }
`;

export const surveyQueryDocument = gql`
  query SurveyQueryOnboarding($input: GetSurveyInput!) {
    survey(input: $input) {
      id
      key
      questions {
        id
        description
        text
        questionType
        multipleChoiceConfiguration {
          questionChoiceType
          options {
            id
            description
            text
          }
          scale {
            from
            to
          }
        }
      }
    }
  }
`;

export const useSurveyOnboarding = (key: string) => {
  const [isLoading, setIsLoading] = useState(false);

  const {data, loading: queryLoading} = useSurveyQueryOnboarding({
    variables: {
      input: {key},
    },
  });
  const [saveSurveyOnboarding] = useSaveSurveyOnboarding();
  const {survey} = data || {};

  const handleSubmitSurveyOnboarding = async (
    surveyAnswers: QuestionResponse[],
    options?: OnSubmitSurveryOpts,
  ) => {
    if (survey) {
      setIsLoading(true);
      try {
        await saveSurveyOnboarding({
          variables: {
            input: {
              surveyId: survey.id,
              surveyKey: survey.key,
              answers: surveyAnswers,
            },
          },
        });
      } catch (error) {
        console.error('Error survey save!');
      } finally {
        setIsLoading(false);
        options?.onSuccess?.();
      }
    } else {
      console.error('Missing survey information!');
    }
  };

  return {
    data: survey,
    loading: queryLoading || isLoading,
    handleSave: handleSubmitSurveyOnboarding,
  };
};
